import React, { Component } from 'react';
import '../css/scroll-indicator.css'

class ScrollIndicator extends Component {
    
      componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = (scrollTop / scrollHeight) * 100;
    document.getElementById('scroll-indicator').style.width = scrolled + '%';
  };
  
    render() { 
        return (
            <>
                <div id='scroll-indicator'></div>
            </>
        );
    }
}
 
export default ScrollIndicator;